define('areas/clientteam/models/bindable',["require", "exports"], function (require, exports) {
    "use strict";
    var Members = (function () {
        function Members() {
        }
        return Members;
    }());
    exports.Members = Members;
});

